/* Registrations.js */

"use strict";
module.exports = {
    REPORT_CENTER_SECTION: "App.GameConsole.Section.ReportCenter",
    REPORT_GENERATOR_EDITOR: "App.GameConsole.Section.ReportCenter.Editors.ReportGeneratorEditor",
};
Object.freeze(module.exports);
